import ShUserAvatar from '@/components/Helpers/ShUserAvatar';

// @vue/component
export default {
  name: 'UserData',

  components: {
    ShUserAvatar,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    goToUserProfile() {
      this.$EventBus.$emit('SHOW_USER_PROFILE', { user: this.user, shouldRefreshList: false });
    },
    handleCloseMobileMenu() {
      if (this.$store.state.app.isMenuExpanded) {
        this.$store.dispatch('app/toggleMenu');
      }
    },
  },
};
